import ProjectsService from '@/services/ProjectsService.js'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    projects: [],
    contentType: ''
  },
  mutations: {
    SET_CONTENT_TYPE(state, contentType) {
      console.log('SET_CONTENT_TYPE = ', contentType)
      state.contentType = contentType
    },
    SET_PROJECT_DATA(state, projects) {
      console.log('SET_PROJECT_DATA = ', projects)
      state.projects = projects.items
    },
    RESET_PROJECT_DATA(state) {
      console.log('RESET_PROJECT_DATA')
      state.projects = ''
    },
    SET_IS_LOADING(state, isLoading) {
      state.isLoading = isLoading
    }
  },
  actions: {
    async fetchProjects({ commit }, contentType) {
      commit('RESET_PROJECT_DATA')
      commit('SET_IS_LOADING', true)
      await ProjectsService.getProjects(contentType)
        .then(response => {
          // console.log('response = ', response)
          commit('SET_IS_LOADING', false)
          commit('SET_PROJECT_DATA', response)
        })
        .catch(error => {
          console.log('There was a problem fetching projects: ' + error.message)
          throw error
        })
    }
  }
}
